
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

Swiper.use([Navigation, Pagination])

export const RestaurantEventSlider = () => {
  const $sliderWrapper = $('.js-restaurantEventSlider__slider');
  if ( !$sliderWrapper.length ) {
      return
  }

  $(document).ready(function() {
    const slider = new Swiper('.js-restaurantEventSlider__slider', {
      pagination: {
        el: '.js-restaurantEventSlider__pagination',
        clickable: true,
      },
  
      // Navigation arrows
      navigation: {
        nextEl: '.js-restaurantEventSlider__nextSlide',
        prevEl: '.js-restaurantEventSlider__prevSlide',
      },
    })
    console.log(slider)
  });
}